// extracted by mini-css-extract-plugin
export default {"loadingSpinnerContainer":"Spinner_loadingSpinnerContainer__xVPTs","loadingSpinner":"Spinner_loadingSpinner__I9lqY","spin":"Spinner_spin__ptI2n"};